// Monthly cost range for the public Benefits Proposal (/quote/:token).
// The price-filter slider needs whole-dollar bounds that contain every plan
// (floor min, ceil max), but displayed text must show the real premiums —
// a single $2,908.95 plan used to read "$2,908.00 - $2,909.00".
//
// Pure: no React.

export type PlanCostRange = {
  /** Real cheapest premium (0 when no priced plans). */
  min: number;
  /** Real most expensive premium (0 when no priced plans). */
  max: number;
  /** Slider lower bound: floor(min) so every plan passes by default. */
  sliderMin: number;
  /** Slider upper bound: ceil(max) so every plan passes by default. */
  sliderMax: number;
};

export function computePlanCostRange(premiums: number[]): PlanCostRange {
  const costs = premiums.filter((c) => Number.isFinite(c) && c > 0);
  if (costs.length === 0) return { min: 0, max: 0, sliderMin: 0, sliderMax: 10000 };
  const min = Math.min(...costs);
  const max = Math.max(...costs);
  return { min, max, sliderMin: Math.floor(min), sliderMax: Math.ceil(max) };
}

const usd = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 });

/** "$2,908.95" when min and max match to the cent, else "$1,200.50 - $2,908.95". */
export function formatMonthlyRange(min: number, max: number): string {
  const lo = usd.format(min);
  const hi = usd.format(max);
  return lo === hi ? lo : `${lo} - ${hi}`;
}
